import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.object.keys";
import _defineProperty from "E:/hongyou/background_ui/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
// 国际化
// 1.导入vue-i18n
import Vue from 'vue';
import VueI18n from 'vue-i18n';
// 导入语言包
import en from "./myen";
import zh from "./myzh";
// 导入element-ui国际化
import Element from 'element-ui';
import enLocale from 'element-ui/lib/locale/lang/en';
import zhLocale from 'element-ui/lib/locale/lang/zh-CN';
Vue.use(VueI18n);

// 2.配置语言
var messages = {
  // 英文语言
  myen: _objectSpread(_objectSpread({}, en), enLocale),
  // 中文语言
  myzh: _objectSpread(_objectSpread({}, zh), zhLocale)
};

// 3. 设置语言
var _i18n = new VueI18n({
  locale: 'myzh',
  // 默认本地语言
  messages: messages // 设置地区信息
});

Vue.use(Element, {
  i18n: function i18n(key, value) {
    return _i18n.t(key, value);
  }
});

// 4.挂载vue实例  导出i18n
export default _i18n;